
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useMediaQuery, useTheme } from '@mui/material';
import Certificate from '../components/Courses/Certificate';
import QuizMessage from '../components/Courses/QuizMessage';
import img1 from '../Assets/Images/TrainingCertificate.png';
import certificateEng from '../Assets/Images/CertificateEng.png';
import certificateNor from '../Assets/Images/CertificateNor.png';
import Modal from 'react-modal';
import RatingModal from '../components/Quiz/RatingModal';
import QuizButtons from '../components/Quiz/QuizButtons';
import QuizOptions from '../components/Quiz/QuizOptions';
import { getUserFullName } from '../utils/user.utils.js';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import {
    CardContent,
    Typography,
    Box,
    CircularProgress,
    LinearProgress
} from '@mui/material';
import axiosInstance from '../axios.config';
import { ContentBlock } from '../shared/sharedStyles';
import CongratulatoryComponent from '../components/Quiz/CongratulatoryComponent';

Modal.setAppElement('#root'); // Bind modal to your app root

const StartQuiz = () => {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const lngsltd = JSON.parse(localStorage.getItem('languageSelected'));
    const culture = JSON.parse(localStorage.getItem('cultureSelected')) || 'en-US';
    const certificateImage = culture === 'en-US' ? certificateEng : certificateNor;
    const navigate = useNavigate();
    const { courseid } = useParams();
    const [currentQuiz, setCurrentQuiz] = useState(null);
    const [open, setOpen] = useState(false);
    const [scoreData, setScoreData] = useState({ score: 0, totalScore: 0, percentage: 0 });
    const [questions, setQuestions] = useState([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [userQuiz, setUserQuiz] = useState(null);
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [courseName, setCourseName] = useState();

    const [showOptions, setShowOptions] = useState(false);
    const [showCertificate, setShowCertificate] = useState(false);
    const [certificateData, setCertificateData] = useState({});

    //For Rating and Comments
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const userID = userDetails.userID;


    const [correctOptions, setCorrectOptions] = useState([]);
    const [incorrectOptions, setIncorrectOptions] = useState([]);
    const [isLocked, setIsLocked] = useState(false);
    const [lockedQuestions, setLockedQuestions] = useState([]);
    const [userSelections, setUserSelections] = useState([]);
    const [correctAnswers, setCorrectAnswers] = useState([]);

    const [showCongrats, setShowCongrats] = useState(false);
    const [isCongratulatoryMessageOpen, setIsCongratulatoryMessageOpen] = useState(false);


    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // For mobile devices
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // For tablets
    const isLaptop = useMediaQuery(theme.breakpoints.between('md', 'lg')); // For laptops
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg')); // For big screens
    const isVerySmallScreen = useMediaQuery('(max-width:400px)'); // For screens smaller than 400px

    // const incorrectTone = `${process.env.PUBLIC_URL}/sounds/incorrect.mp3`;
    // const incorrectTone = `${process.env.PUBLIC_URL}/sounds/incorrect2.mp3`;
    // const incorrectToneAudio = `${process.env.PUBLIC_URL}/sounds/wrong-answer.mp3`;
    // const correctTone = `${process.env.PUBLIC_URL}/sounds/correct.mp3`;
    //const correctToneAudio = `${process.env.PUBLIC_URL}/sounds/correct-answer.mp3`;

    // Create new Audio objects within the handler
    const correctTone = new Audio(`${process.env.PUBLIC_URL}/sounds/correct-answer.mp3`);
    const incorrectTone = new Audio(`${process.env.PUBLIC_URL}/sounds/wrong-answer.mp3`);

    // Optionally, preload these sounds to ensure they are ready
    incorrectTone.preload = 'auto';
    correctTone.preload = 'auto';

    // Create Audio objects for correct and incorrect tones
    // const incorrectTone = new Audio(incorrectToneAudio);
    // const correctTone = new Audio(correctToneAudio);

    //Environment variables
    const apiUrl = process.env.REACT_APP_API_URL;

    const currentQuestion = questions[currentQuestionIndex];
    const options = currentQuestion?.options || [];
    // const questionType = currentQuestion?.type || 'Multiple Choice';

    const userInfos = useSelector((state) => state.authState.userInfos)
    const userFullName = useMemo(() => getUserFullName(userInfos))

    const languagecultureSelected = JSON.parse(localStorage.getItem('cultureSelected'));

    // useEffect(() => {
    //     // Preload the sounds
    //     incorrectTone.preload = 'auto';
    //     correctTone.preload = 'auto';
    // }, []);

    useEffect(() => {
        fetchQuiz();
    }, [courseid]);

    const fetchQuiz = async () => {
        try {
            const response = await axiosInstance.get(`/Quiz/ByCourse/${courseid}`);
            setCurrentQuiz(response.data);
            const coursename = await axiosInstance.get(`/Course/${courseid}`);
            setCourseName(coursename.data.courseName);

            const questionsResponse = await axiosInstance.get(`/Question/QuizID/${response.data.quizID}/${languagecultureSelected}`);
            const parsedQuestions = questionsResponse.data.map(question => ({
                ...question,
                options: question.options.split(','),
                correctOption: question.correctOption.split(',')
            }));

            setQuestions(parsedQuestions);
            setSelectedAnswers(Array(parsedQuestions.length).fill([])); // Initialize selectedAnswers
            createUserQuiz(response.data.quizID);
        } catch (error) {
            console.error('Error fetching quiz:', error);
        } finally {
            setLoading(false);
        }
    };

    const createUserQuiz = async (quizId) => {
        try {
            const currentTime = new Date();
            const userId = userDetails.userID;
            const userQuizData = {
                userQuizID: 0,
                userID: userId,
                quizID: quizId,
                startTime: currentTime,
                endTime: currentTime,
                score: 0
            };

            const response = await axiosInstance.post(`/UserQuiz`, userQuizData);
            setUserQuiz(response.data);
        } catch (error) {
            console.error('Error creating user quiz:', error);
        }
    };

    const playSound = (tone) => {
        const audio = new Audio(tone);
        audio.play();
    };

    const handleOptionChange = (event, option) => {
        const currentIndex = currentQuestionIndex;

        // Early exit if the question is locked
        if (lockedQuestions.includes(currentIndex)) {
            return;
        }

        let updatedAnswers = [...selectedAnswers];
        const correctOptions = questions[currentIndex].correctOption;

        if (questions[currentIndex].questionType === 'Multiple Choice') {
            const currentSelection = updatedAnswers[currentIndex] ? [...updatedAnswers[currentIndex]] : [];

            if (currentSelection.includes(option)) {
                updatedAnswers[currentIndex] = currentSelection.filter(o => o !== option);
            } else {
                updatedAnswers[currentIndex] = [...currentSelection, option];
            }

            const hasSelectedEnough = updatedAnswers[currentIndex].length === correctOptions.length;

            if (hasSelectedEnough) {
                const isAllCorrect = correctOptions.every(opt => updatedAnswers[currentIndex].includes(opt));
                const isAnyWrong = updatedAnswers[currentIndex].some(opt => !correctOptions.includes(opt));

                if (isAnyWrong) {
                    incorrectTone.play().catch(error => console.error('Error playing incorrect tone:', error));
                } else if (isAllCorrect) {
                    correctTone.play().catch(error => console.error('Error playing correct tone:', error));
                    setLockedQuestions(prev => [...prev, currentIndex]);
                }
            }
        } else {
            updatedAnswers[currentIndex] = [option];

            if (correctOptions.includes(option)) {
                correctTone.play().catch(error => console.error('Error playing correct tone:', error));
            } else {
                incorrectTone.play().catch(error => console.error('Error playing incorrect tone:', error));
            }

            setLockedQuestions(prev => [...prev, currentIndex]);
        }

        setSelectedAnswers(updatedAnswers);
        saveUserAnswer(updatedAnswers[currentIndex], currentIndex);
    };




    // The class logic for rendering options
    const getOptionClass = (option) => {
        const currentQuestion = questions[currentQuestionIndex];
        const isCorrect = currentQuestion.correctOption.includes(option);
        const isSelected = isOptionSelected(option);
        const hasAttempted = lockedQuestions.includes(currentQuestionIndex);

        //console.log("Option class check:", { option, isCorrect, isSelected, hasAttempted });

        if (hasAttempted) {
            if (isCorrect && isSelected) {
                return "option correct-answer";
            } else if (!isCorrect && isSelected) {
                return "option wrong-answer";
            } else if (isCorrect) {
                return "option correct-answer";
            }
        } else if (isSelected) {
            return "option selected"; // Option is selected but not yet evaluated
        }

        return "option"; // Default state for unselected/unanswered options
    };


    const saveUserAnswer = async (selectedOptions, questionIndex) => {
        const currentQuestion = questions[questionIndex];
        const sortedSelectedOptions = selectedOptions.slice().sort();
        const sortedCorrectOptions = currentQuestion.correctOption.slice().sort();

        // Only save if all required options are selected
        if (sortedSelectedOptions.length === sortedCorrectOptions.length) {
            const userAnswerData = {
                userAnswerID: 0,
                userQuizID: userQuiz.userQuizID,
                questionID: currentQuestion.id,
                selectedAnswer: sortedSelectedOptions.join(','),
                correctAnswer: sortedCorrectOptions.join(','),
                isCorrect: JSON.stringify(sortedSelectedOptions) === JSON.stringify(sortedCorrectOptions)
            };

            try {
                await axiosInstance.post(`/UserAnswer`, userAnswerData);
            } catch (error) {
                //console.error('Error saving user answer:', error);
            }

            // Update state based on correctness
            setCorrectAnswers(sortedCorrectOptions);
            setUserSelections(sortedSelectedOptions);
            setLockedQuestions(prev => [...prev, questionIndex]);
        } else {
            //console.log("Not enough options selected to save the answer");
        }
    };

    const isOptionSelected = (option) => {
        const currentIndex = currentQuestionIndex;
        const currentSelection = selectedAnswers[currentIndex] || [];
        return currentSelection.includes(option);
    };

    const handleSubmit = async () => {
        // Save the last question's answer
        saveUserAnswer(selectedAnswers[currentQuestionIndex], currentQuestionIndex);
        // Once all answers are saved, update the quiz score
        await UpdateUserQuiz();

        // const percentage = (score / totalScore) * 100;


    };

    const UpdateUserQuiz = async () => {
        try {
            const userAnswersResponse = await axiosInstance.get(`/UserAnswer/userQuizID/${userQuiz.userQuizID}`);
            const allUserAnswers = userAnswersResponse.data;

            const questionsResponse = await axiosInstance.get(
                `/Question/QuizID/${userQuiz.quizID}/${languagecultureSelected}`
            );

            const currentQuestions = questionsResponse.data;

            // Get only existing question IDs
            const currentQuestionIds = currentQuestions.map(q => q.id);

            // Remove answers for deleted questions
            const validUserAnswers = allUserAnswers.filter(answer =>
                currentQuestionIds.includes(answer.questionID)
            );
            debugger;
            const score = calculateScore(validUserAnswers);
            const totalScore = currentQuestions.length;
            const currentTime = new Date();

            const percentage =
                totalScore > 0 ? (score / totalScore) * 100 : 0;

            const userQuizData = {
                userQuizID: userQuiz.userQuizID,
                userID: userQuiz.userID,
                quizID: userQuiz.quizID,
                startTime: userQuiz.startTime,
                endTime: currentTime,
                score: score
            };


            // here we are updating the UserCourse, so that if the user don't give feedback, then also we can show course completed
            const userCourseData = {
                UserID: userID,
                CourseID: courseid,
                IsCourseCompleted: true,
                EndTime: new Date().toISOString(),
                Rating: rating,
                Comments: comment.trim() === '' ? null : comment
                // Comment: comment
            };
            await axiosInstance.put(`/UserCourse/UpdateUserCourse?userId=${userCourseData.UserID}&courseId=${userCourseData.CourseID}&isCourseCompleted=${userCourseData.IsCourseCompleted}&endTime=${userCourseData.EndTime}&rating=${userCourseData.Rating}&comments=${userCourseData.Comments}`, {}, {
            });

            await axiosInstance.put(`/UserQuiz/${userQuizData.userQuizID}`, userQuizData);
            debugger;
            if (percentage >= 90) {
                setCertificateData({
                    userName: userDetails.userName,
                    score: score,
                    percentage: Math.round(percentage),
                    certificateImageUrl: certificateImage, // Replace with actual image URL
                    courseName: courseName,
                    userQuizID: userQuizData.userQuizID,
                    userID: userQuizData.userID,
                    quizID: userQuizData.quizID,
                    startTime: userQuizData.startTime,
                    endTime: currentTime,

                });
                setShowCongrats(true);
                setTimeout(() => {
                    setShowOptions(true); // Show options for "Retake" or "Continue"
                }, 1000);

            } else {
                // Handle non-eligible case
                setOpen(true);
            }

            setScoreData({ score, totalScore, percentage });
            //setOpen(true);
        } catch (error) {
            //console.error('Error updating user quiz:', error);
        }
    };

    const handleContinue = () => {
        setShowCertificate(true);
        setShowCongrats(false)
        setShowOptions(false);
    };

    const handlecertificateClose = () => {
        setShowCertificate(false);
        setShowCongrats(false);
        setIsModalOpen(true);
        //navigate('/courses');
    };

    const handleRetake = () => {

        // Reset the quiz state to start from the beginning
        setCurrentQuestionIndex(0);
        setSelectedAnswers([]);
        setScoreData({});
        setShowOptions(false);
        setShowCertificate(false);
        setShowCongrats(false)
        // Navigate back to the quiz start page with the course ID

        navigate(`/startcoursepage/${courseid}`)
        //navigate(`/startquiz/${courseid}`);

    };

    const handleExit = () => {
        setShowCongrats(false)
        navigate(`/courses`)
    };

    const calculateScore = (userAnswers) => {
        let score = 0;
        for (let i = 0; i < userAnswers.length; i++) {
            const userAnswer = userAnswers[i];
            if (userAnswer.isCorrect) {
                score++;
            }
        }
        return score;
    };

    const handleNextQuestion = () => {
        const currentIndex = currentQuestionIndex;
        const currentSelection = selectedAnswers[currentIndex] || [];
        const correctOptions = questions[currentIndex].correctOption;

        // Check if the number of selected options is less than the required number
        if (questions[currentIndex].questionType === 'Multiple Choice' && currentSelection.length < correctOptions.length) {
            toast.info(`Please select all ${correctOptions.length} correct answers before proceeding.`, { className: "custom-toast-fontsize" });
            return;
        }

        // Reset isLocked state to ensure that the user can interact with the next question
        setIsLocked(false);

        // Ensure previous selections are reset before moving to the next question
        if (selectedAnswers[currentQuestionIndex]?.length > 0) {
            if (currentQuestionIndex === questions.length - 1) {
                handleSubmit();  // Submit the final answer and update the quiz
            } else {
                saveUserAnswer(selectedAnswers[currentQuestionIndex], currentQuestionIndex);
                // Reset styles and selected options before moving to the next question
                // setSelectedAnswers(prev => {
                //     const updated = [...prev];
                //     updated[currentQuestionIndex] = []; // Clear the selection for the current question
                //     return updated;
                // });
                setCurrentQuestionIndex(prevIndex => prevIndex + 1);
            }
        } else {
            toast.info("Please select an option before proceeding to the next question.",
                { className: "custom-toast-fontsize" }
            );
        }
    };


    const handleModalSubmit = async () => {
        try {
            // Send PUT request to update UserCourseStep status          
            const userCourseData = {
                UserID: userID,
                CourseID: courseid,
                IsCourseCompleted: true,
                EndTime: new Date().toISOString(),
                Rating: rating,
                Comments: comment.trim() === '' ? null : comment
                // Comment: comment
            };
            await axiosInstance.put(`/UserCourse/UpdateUserCourse?userId=${userCourseData.UserID}&courseId=${userCourseData.CourseID}&isCourseCompleted=${userCourseData.IsCourseCompleted}&endTime=${userCourseData.EndTime}&rating=${userCourseData.Rating}&comments=${userCourseData.Comments}`, {}, {
            });

            setIsModalOpen(false); // Close the modal
            navigate(`/courses`);
        }
        catch (error) {
            //toast.error(lngsltd['Failed to submit course']);
        }

    };

    const handleModalClose = () => {
        setIsModalOpen(false);
    };

    const handlePrevious = () => {
        setCurrentQuestionIndex(prevIndex => prevIndex - 1);
    };

    const handleClose = () => {
        setOpen(false);
        setUserQuiz(null);
        //navigate(`/courses`);
    };


    const handleConfirmExit = () => {
        // console.log("handleConfirmExit called");
        // setOpenConfirmation(true);
        navigate(`/courses`);
    };

    const handleConfirm = () => {
        setOpenConfirmation(false);
        navigate(`/courses`);
    };

    const handleConfirmClose = () => {
        setOpenConfirmation(false);
    };

    return (
        <Box
            className="startquiz-container"
            m={1}
            p={1}
            sx={{
                fontSize: isMobile ? '0.575rem' : '1rem', // Decrease font size on mobile
                width: isMobile ? '96%' : 'auto', // Increase width on mobile
                height: isMobile ? 'auto' : 'auto', // Adjust height as needed
                //overflow: 'hidden', // Ensure content fits within the container
                minHeight: '100%',
                mb: 2
            }}
        >
            <ToastContainer
                position="top-center"
                autoClose={2000}
                newestOnTop={false}
                closeOnClick
                progressClassName='custom-toast-progress-bar'
            />
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    {/* Quiz Header with Progress */}
                    <Box
                        sx={{
                            mb: 3,
                            width: '100%',
                            maxWidth: '100%'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                                mb: 3
                            }}
                        >
                            {/* Quiz Title */}
                            <Typography
                                variant="h4"
                                sx={{
                                    fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                                    fontWeight: 700,
                                    color: '#212529',
                                    textAlign: 'center',
                                    letterSpacing: '-0.02em'
                                }}
                            >
                                {currentQuiz ? currentQuiz.title : "Quiz"}
                            </Typography>

                            {/* Progress Bar Section */}
                            <Box
                                sx={{
                                    width: '100%',
                                    px: { xs: 1, sm: 2 }
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        mb: 1
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontSize: { xs: '0.875rem', sm: '1rem' },
                                            fontWeight: 600,
                                            color: '#6c757d'
                                        }}
                                    >
                                        {lngsltd["Question"] || "Question"} {currentQuestionIndex + 1} {lngsltd["of"] || "of"} {questions.length}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontSize: { xs: '0.875rem', sm: '1rem' },
                                            fontWeight: 600,
                                            color: '#dc3545'
                                        }}
                                    >
                                        {Math.round(((currentQuestionIndex + 1) / questions.length) * 100)}%
                                    </Typography>
                                </Box>
                                <LinearProgress
                                    variant="determinate"
                                    value={((currentQuestionIndex + 1) / questions.length) * 100}
                                    sx={{
                                        height: 8,
                                        borderRadius: '4px',
                                        backgroundColor: '#e5e7eb',
                                        '& .MuiLinearProgress-bar': {
                                            borderRadius: '4px',
                                            background: 'linear-gradient(90deg, #dc3545 0%, #c82333 100%)',
                                            boxShadow: '0 2px 8px rgba(220, 53, 69, 0.3)'
                                        }
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: {
                                xs: 'auto',
                                sm: 'calc(100vh - 280px)',
                                md: 'calc(100vh - 320px)',
                                lg: 'calc(100vh - 340px)',
                            },
                            minHeight: {
                                xs: 'auto',
                                md: '500px'
                            },
                            mb: { xs: '100px', sm: '90px' },
                            width: '100%',
                            maxWidth: '100%'
                        }}
                    >
                        <ContentBlock
                            className="quiz-card"
                            sx={{
                                alignItems: 'start',
                                flex: 1,
                                margin: isMobile ? '0.5rem' : 'auto',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                                borderRadius: '16px',
                                p: { xs: 2, sm: 3, md: 4 },
                                mb: 2
                            }}
                        >
                            {questions[currentQuestionIndex] && questions[currentQuestionIndex].imageName && questions[currentQuestionIndex].imageName !== "No Image" && questions[currentQuestionIndex].imageName !== null && (
                                <Box
                                    className="quiz-image"
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: "100%",
                                        mb: 3,
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        backgroundColor: '#f8f9fa'
                                    }}
                                >
                                    <img
                                        src={`${apiUrl}/Question/Image/${questions[currentQuestionIndex].quizID}/${questions[currentQuestionIndex].questionNo}/${questions[currentQuestionIndex].imageName}`}
                                        alt="Question"
                                        onError={(e) => {
                                            // Hide the entire image container if image fails to load
                                            const container = e.target.closest('.quiz-image');
                                            if (container) {
                                                container.style.display = 'none';
                                            }
                                        }}
                                        onLoad={(e) => {
                                            // Ensure container is visible when image loads successfully
                                            const container = e.target.closest('.quiz-image');
                                            if (container) {
                                                container.style.display = 'flex';
                                            }
                                        }}
                                        style={{
                                            width: 'auto',
                                            maxWidth: '100%',
                                            maxHeight: '35vh',
                                            height: 'auto',
                                            objectFit: 'contain',
                                            borderRadius: '12px'
                                        }}
                                    />
                                </Box>
                            )}
                            <CardContent
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: "100%",
                                    p: 0,
                                    '&:last-child': { pb: 0 }
                                }}
                            >
                                <Box sx={{ flex: 1 }}>
                                    {questions[currentQuestionIndex] && (
                                        <>
                                            <Typography
                                                variant={isMobile ? "h6" : "h5"}
                                                gutterBottom
                                                sx={{
                                                    fontWeight: 600,
                                                    color: '#212529',
                                                    mb: 3,
                                                    lineHeight: 1.4,
                                                    fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' }
                                                }}
                                            >
                                                {questions[currentQuestionIndex].questionText}
                                            </Typography>
                                            <QuizOptions
                                                options={options}
                                                questionType={questions[currentQuestionIndex].questionType}
                                                isOptionSelected={isOptionSelected}
                                                handleOptionChange={handleOptionChange}
                                                lockedQuestions={lockedQuestions}
                                                currentQuestionIndex={currentQuestionIndex}
                                                getOptionClass={getOptionClass}
                                                selectedAnswers={selectedAnswers}
                                                lngsltd={lngsltd}
                                            />
                                        </>
                                    )}
                                </Box>
                            </CardContent>
                        </ContentBlock>

                        {/* Fixed Navigation Buttons */}
                        <Box
                            sx={{
                                position: 'fixed',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                backgroundColor: '#ffffff',
                                borderTop: '1px solid #e5e7eb',
                                boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.08)',
                                zIndex: 1000,
                                px: { xs: 2, sm: 3, md: 4 },
                                py: { xs: 2, sm: 2.5, md: 3 },
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                '& > *': {
                                    maxWidth: '100%',
                                    width: '100%'
                                }
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexDirection: isVerySmallScreen ? 'column' : 'row',
                                    gap: isVerySmallScreen ? 2 : 0,
                                    width: '100%',
                                    maxWidth: isMobile ? '100%' : '1200px',
                                    mx: 'auto'
                                }}
                            >
                                <QuizButtons
                                    isVerySmallScreen={isVerySmallScreen}
                                    isMobile={isMobile}
                                    currentQuestionIndex={currentQuestionIndex}
                                    handlePrevious={handlePrevious}
                                    handleNextQuestion={handleNextQuestion}
                                    handleConfirmExit={handleConfirmExit}
                                    lngsltd={lngsltd}
                                    questions={questions}
                                />
                            </Box>
                        </Box>
                    </Box>


                    {/* Certificate Modal */}
                    {showCertificate && (
                        <Certificate
                            userName={certificateData.userName}
                            score={certificateData.score}
                            percentage={certificateData.percentage}
                            certificateImageUrl={certificateData.certificateImageUrl}
                            open={showCertificate}
                            courseName={certificateData.courseName}
                            onClose={handlecertificateClose}
                            overlayText={userFullName}
                            lngsltd={lngsltd}
                            userQuizID={certificateData.userQuizID}
                            userID={certificateData.userID}
                            quizID={certificateData.quizID}
                            startTime={certificateData.startTime}
                            endTime={certificateData.endTime}
                            courseid={courseid}
                        />
                    )}

                    {/* Show options for "Retake" or "Continue" */}
                    <QuizMessage
                        showOptions={showOptions}
                        open={open}
                        handleRetake={handleRetake}
                        handleContinue={handleContinue}
                        handleExit={handleExit}
                        certificateData={certificateData}
                        lngsltd={lngsltd}
                    />

                    {/* Congratulatoy */}
                    <CongratulatoryComponent isVisible={showCongrats} />

                    <RatingModal
                        isModalOpen={isModalOpen}
                        handleModalClose={handleModalClose}
                        rating={rating}
                        setRating={setRating}
                        comment={comment}
                        setComment={setComment}
                        handleModalSubmit={handleModalSubmit}
                        isMobile={isMobile}
                        lngsltd={lngsltd}
                    />
                </>
            )}
        </Box>
    );
};

export default StartQuiz;
